/* xlsx.js (C) 2013-present  SheetJS -- http://sheetjs.com */
/* Notes:
   - usage: `ReactDOM.render( <SheetJSApp />, document.getElementById('app') );`
   - xlsx.full.min.js is loaded in the head of the HTML page
   - this script should be referenced with type="text/babel"
   - babel.js in-browser transpiler should be loaded before this script
*/
import React from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import {
  HamburgerIcon,
  ChevronDownIcon,
  LinkIcon,
  CalendarIcon,
} from "@chakra-ui/icons";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Button,
  Center,
  Box,
  Text,
  IconButton,
  Flex,
  Spacer,
  Image,
  Wrap,
  WrapItem,
  Stack,
  Icon,
  HStack,
  Table,
  Tr,
  Td,
  Tbody,
  Th,
  Thead,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import axios from "axios";

import * as XLSX from "xlsx/xlsx.mjs";
import * as objs from "../../objs";

/* "HA" => "Hallam",
            "BE" => "Bendigo",
            "SA" => "Sale",
            "SU" => "Sunshine",
            "BA" => "Ballarat",
            "RI" => "Ridetek"*/

var allBranchsSelection = [
  ["Hallam", "HA"],
  ["Bendigo", "BE"],
  ["Sale", "SA"],
  ["Sunshine", "SU"],
  ["Ballarat", "BA"],
  ["Ridetek", "RI"],
];

var allMonths = [
  ["", 0],
  ["January", 1],
  ["February", 2],
  ["March", 3],
  ["April", 4],
  ["May", 5],
  ["June", 6],
  ["July", 7],
  ["August", 8],
  ["September", 9],
  ["October", 10],
  ["November", 11],
  ["December", 12],
];

var allMonthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

class Invoices extends React.Component {
  state = {
    invoices: [],
    payments: [],
    refunds: [],
    bookings: [],
    lstObjs: [],
    lstCreditObjs: [],
    lstCreditMap: new Map(),
    selectedYear: "2022",
    selectedMonth: "03",
    lstCreditedInvoices: [],
    selectedBranch: "all",
  };

  /*var bookings = await this.downloadData("allBookings", false);

    var refunds = await this.downloadData("allRefunds", false);

    var payments = await this.downloadData("allPayments", false);

    var invoices = await this.downloadData("allinvoices", false);

    var credited = await this.downloadData("allinvoices", true);*/
  componentDidMount() {
    this.addMoreListeners();
    this.requestCurrentMonthData();
    // this.loadData();

    const d = new Date();
    let year = d.getFullYear();
    let month = d.getMonth();
    var day = new Date(year, month + 1, 0).getDate();
  }

  async addMoreListeners() {
    this.props.chatSocket.on("getInvoiceData", (data) => {
      var j = JSON.parse(data);
      console.log(j);
      //var lstgetInvoiceData = {aBookings:aBookings["data"],aRefunds:aRefunds["data"],aPayments:aPayments["data"],aCredit:aCredit["data"]};
      this.loadData(
        j["aBookings"],
        j["aRefunds"],
        j["aPayments"],
        j["aCredit"],
        j["aInvoices"]
      );
    });
  }

  requestCurrentMonthData() {
    const d = new Date();
    let year = d.getFullYear();
    let month = d.getMonth();
    this.requestData(month + 1, year);
  }

  requestData(selectedMonth, selectedyear) {
    var day = new Date(selectedyear, selectedMonth + 1, 0).getDate();

    var startDate = selectedyear + "-" + selectedMonth + "-01";
    var endDate = selectedyear + "-" + selectedMonth + "-" + day;

    this.props.chatSocket.emit(
      "getInvoiceData",
      JSON.stringify({
        startDate: startDate,
        endDate: endDate,
      })
    );

    this.setState({
      selectedYear: selectedyear,
      selectedMonth: selectedMonth,
    });
  }

  async downloadData(item, cr) {
    const { selectedYear, selectedMonth } = this.state;
    console.log("http://localhost/php/reporting/invoices.php?" + item + "=yay");
    //172.105.171.169

    var startDate = this.props.startDate;
    var endDate = this.props.endDate;

    if (!startDate || !endDate) {
      console.log("---------------");
      const d = new Date();
      let year = d.getFullYear();
      let month = d.getMonth();
      var day = new Date(year, month + 1, 0).getDate();
      startDate = selectedYear + "-" + selectedMonth + "-01";
      endDate = selectedYear + "-" + selectedMonth + "-" + day;
    }
    var link =
      "http://localhost/php/reporting/invoices.php?" +
      item +
      "=yay&startDate=" +
      startDate +
      "&endDate=" +
      endDate;

    if (cr) {
      link += "&cr=yay";
    }
    const res = await axios.get(link);
    console.log(link);
    var data = res["data"];
    return data;
  }

  async loadData(bookings, refunds, payments, credited, invoices) {
    /*var bookings = await this.downloadData("allBookings", false);

    var refunds = await this.downloadData("allRefunds", false);

    var payments = await this.downloadData("allPayments", false);

    var invoices = await this.downloadData("allinvoices", false);

    var credited = await this.downloadData("allinvoices", true);*/

    var lstCreditedIn = [];

    for (var c in credited) {
      lstCreditedIn.push(credited[c]["invoice_number"]);
    }

    //console.log(lstCreditedIn);

    var lstObjs = [];
    var lstCreditObjs = [];
    var uniqInvoices = new Map();
    var lstCreditMap = new Map();

    for (var i in invoices) {
      uniqInvoices.set(
        invoices[i]["invoice_id"] +
          "," +
          invoices[i]["invoice_number"] +
          "," +
          invoices[i]["invoice_due_date"]
      );
      var tmpNum = invoices[i]["invoice_number"].replace("-CR", "");
      if (invoices[i]["invoice_number"].includes("-CR")) {
        lstCreditMap.set(tmpNum);
      }
    }
    //console.log(lstCreditMap);
    for (const [key, value] of uniqInvoices.entries()) {
      var s = key.split(",");
      var id = s[0];
      var num = s[1];

      if (!num.includes("-CR")) {
        lstObjs.push(new objs.objInvoices(id, num, s[2]));
      } else {
        //console.log(id,num);
        var tmpNum = num.replace("-CR", "");
        lstCreditMap.set(tmpNum);
        lstCreditObjs.push(new objs.objInvoices(id, num, s[2]));
      }
    }

    //console.log(lstCreditMap);

    //refund
    //refund_id,refund_reason,refund_amount,refund_record_time,refund_record_by,account_id,refund_penalty_amount
    for (var r in refunds) {
      var tmpObjRefund = new objs.objRefund(
        refunds[r]["refund_id"],
        refunds[r]["refund_reason"],
        refunds[r]["refund_amount"],
        refunds[r]["refund_record_time"],
        refunds[r]["refund_record_by"],
        refunds[r]["account_id"],
        refunds[r]["refund_penalty_amount"]
      );
      if (refunds[r]["refund_id"] != null) {
        var id = refunds[r]["invoice_number"];
        if (id.includes("-CR")) {
          id = id.replace("-CR", "");
        }

        for (var i in lstObjs) {
          if (lstObjs[i].invoice_number == id) {
            lstObjs[i].lstRefunds.push(tmpObjRefund);
            break;
          }
        }
      }
    }

    //payment_id,payment_type,payment_amount,payment_date,payment_by,payment_reference
    for (var r in payments) {
      var tmpObjPayment = new objs.objPayment(
        payments[r]["payment_id"],
        payments[r]["payment_type"],
        payments[r]["payment_amount"],
        payments[r]["payment_date"],
        payments[r]["payment_by"],
        payments[r]["payment_reference"]
      );

      if (payments[r]["payment_id"] != null) {
        var id = payments[r]["invoice_id"];

        for (var i in lstObjs) {
          if (lstObjs[i].invoice_id == id) {
            lstObjs[i].lstPayments.push(tmpObjPayment);
            break;
          }
        }
      }
    }

    //add items to invoices
    for (var i in invoices) {
      var id = invoices[i]["invoice_id"];
      for (var o in lstObjs) {
        if (lstObjs[o].invoice_id == id) {
          lstObjs[o].addItem(invoices[i]);
          break;
        }
      }
      if (lstCreditedIn.includes(lstObjs[o].invoice_number + "-CR")) {
        lstObjs[o].foundCredit = true;
      }
    }

    //adding bookings
    for (var i in bookings) {
      var id = bookings[i]["invoice_id"];
      for (var o in lstObjs) {
        if (lstObjs[o].invoice_id == id) {
          lstObjs[o].lstClients.push(bookings[i]);
          break;
        }
      }
    }

    this.setState({
      invoices: invoices,
      refunds: refunds,
      bookings: bookings,
      refunds: refunds,
      payments: payments,
      lstObjs: lstObjs,
      lstCreditObjs: lstCreditObjs,
      lstCreditMap: lstCreditMap,
      lstCreditedInvoices: lstCreditedIn,
    });
  }

  btnProcess() {
    const { invoices, payments, refunds, bookings } = this.state;
  }

  createCsvData(noRefundOrPayment) {
    var lstTblItems =
      "invoice_id,invoice_number,item_quantity,item_unit_price,item_code,invoice_by,invoice_due_date,branch,date\n";

    var lstTbl =
      "invoice_id,invoice_number,invoice_item_count,invoice_total,branch,date\n";
    for (var i in noRefundOrPayment) {
      var invoice_id = noRefundOrPayment[i].invoice_id;
      var invoice_number = noRefundOrPayment[i].invoice_number;
      var invoice_item_count = 0;
      var invoice_total = 0;

      var branch = "";
      if (invoice_number.includes("-")) {
        branch = invoice_number.split("-")[0];
      }

      for (var t in noRefundOrPayment[i].lstItems) {
        let qun = Number(noRefundOrPayment[i].lstItems[t]["item_quantity"]);
        invoice_item_count += qun;
        invoice_total +=
          noRefundOrPayment[i].lstItems[t]["item_unit_price"] * qun;

        var invoice_date = noRefundOrPayment[i].lstItems[t]["invoice_due_date"];

        lstTblItems +=
          invoice_id +
          "," +
          invoice_number +
          "," +
          noRefundOrPayment[i].lstItems[t]["item_quantity"] +
          "," +
          noRefundOrPayment[i].lstItems[t]["item_unit_price"] +
          "," +
          noRefundOrPayment[i].lstItems[t]["item_code"] +
          "," +
          noRefundOrPayment[i].lstItems[t]["invoice_by"] +
          "," +
          noRefundOrPayment[i].lstItems[t]["invoice_due_date"] +
          "," +
          branch +
          "," +
          invoice_date +
          "\n";
      }

      lstTbl +=
        invoice_id +
        "," +
        invoice_number +
        "," +
        invoice_item_count +
        "," +
        invoice_total +
        "," +
        branch +
        "," +
        noRefundOrPayment[i].invoice_date +
        "\n";
    }
    var re = [lstTbl, lstTblItems];
    //console.log(lstTbl);
    //console.log(lstTblItems);
    return re;
  }

  save(filename, data) {
    const blob = new Blob([data], { type: "text/csv" });
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, filename);
    } else {
      const elem = window.document.createElement("a");
      elem.href = window.URL.createObjectURL(blob);
      elem.download = filename;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
  }

  noRefundOrPaymentcheckInvoices() {
    const { lstObjs, lstCreditMap, lstCreditedInvoices, selectedBranch } =
      this.state;

    //console.log(lstCreditMap);
    var noRefundOrPayment = [];
    var credit = [];
    var other = [];

    var years = new Map();
    var months = new Map();

    for (var i in lstObjs) {
      //var tempDate = moment(lstObjs[i].invoice_date_min).format("DD-MM-YYYY");
      //console.log(tempDate, lstObjs[i].invoice_date_min);
      var s = lstObjs[i].invoice_date_min.split("-");
      years.set(s[2]);
      months.set(s[1]);
    }

    for (var i in lstObjs) {
      if (
        lstObjs[i].lstRefunds.length == 0 &&
        lstObjs[i].lstPayments.length == 0 &&
        !lstObjs[i].invoice_number.includes("-CR") &&
        !lstCreditMap.has(lstObjs[i].invoice_number)
      ) {
        noRefundOrPayment.push(lstObjs[i]);
      } else if (lstObjs[i].invoice_number.includes("-CR")) {
        credit.push(lstObjs[i]);
      } else {
        other.push(lstObjs[i]);
      }
    }

    //var showYears = [];

    for (const [key, value] of years.entries()) {
      /*showYears.push(
        <HStack key={uuidv4()}>
          <Text fontSize="6xl">{key}</Text>
        </HStack>
      );*/

      var showMonthsData = [];

      for (let i = 1; i < allMonths.length; i++) {
        var foundItemsInMonth = false;

        var showMonths = [];
        var showMonthsOwing = [];
        var showMonthsCredited = [];

        showMonths.push(
          <Tr key={uuidv4()}>
            <Th>
              <Text>invoice_id</Text>
            </Th>
            <Th>
              <Text>invoice_number</Text>
            </Th>
            <Th>
              <Text>invoice_due_date</Text>
            </Th>
            <Th>
              <Text>total</Text>
            </Th>
            <Th>
              <Text>credit</Text>
            </Th>
          </Tr>
        );

        for (var il in noRefundOrPayment) {
          var s = noRefundOrPayment[il].invoice_date_min.split("-");
          let matchMonth = Number(s[1]);
          if (matchMonth == i && key == s[2]) {
            foundItemsInMonth = true;
            var invoiceFoundCredit = "";
            if (noRefundOrPayment[il].foundCredit) {
              invoiceFoundCredit = "true";
            }

            var tblData = (
              <Tr key={uuidv4()}>
                <Td>
                  <Text>{noRefundOrPayment[il].invoice_id}</Text>
                </Td>
                <Td>
                  <Text>{noRefundOrPayment[il].invoice_number}</Text>
                </Td>
                <Td>
                  <Text>{noRefundOrPayment[il].invoice_date}</Text>
                </Td>
                <Td>
                  <Text>{noRefundOrPayment[il].total}</Text>
                </Td>
                <Td>
                  <Text>{invoiceFoundCredit}</Text>
                </Td>
              </Tr>
            );

            if (
              selectedBranch == "all" ||
              noRefundOrPayment[il].invoice_number.includes(selectedBranch)
            ) {
              showMonths.push(tblData);
              if (invoiceFoundCredit == "true") {
                showMonthsCredited.push(tblData);
              } else {
                showMonthsOwing.push(tblData);
              }
            }
          }
        }
        if (foundItemsInMonth) {
          showMonthsData.push(
            <Text fontSize="3xl">
              {key}-{allMonths[i][0]}
            </Text>
          );

          /*<Tabs>
            <TabList>
              <Tab>All {showMonths.length}</Tab>
              <Tab>Hallam {showMonths.length}</Tab>
              <Tab>Bendigo {showMonthsOwing.length}</Tab>
              <Tab>Sale {showMonthsCredited.length}</Tab>
              <Tab>Sunshine {showMonthsCredited.length}</Tab>
              <Tab>Ballarat {showMonthsCredited.length}</Tab>
              <Tab>Ridetek {showMonthsCredited.length}</Tab>
            </TabList>
            <TabPanels>
              <TabPanel></TabPanel>
            </TabPanels>
          </Tabs>;*/

          showMonthsData.push(
            <Tabs>
              <TabList>
                <Tab>Both {showMonths.length}</Tab>
                <Tab>Owing {showMonthsOwing.length}</Tab>
                <Tab>Credited {showMonthsCredited.length}</Tab>
              </TabList>

              <TabPanels>
                <TabPanel>
                  <Table>
                    <Tbody>{showMonths}</Tbody>
                  </Table>
                </TabPanel>
                <TabPanel>
                  <Table>
                    <Tbody>{showMonthsOwing}</Tbody>
                  </Table>
                </TabPanel>
                <TabPanel>
                  <Table>
                    <Tbody>{showMonthsCredited}</Tbody>
                  </Table>
                </TabPanel>
              </TabPanels>
            </Tabs>
          );
          // showMonthsData.push(<Table>{showMonths}</Table>);
        }
      }
    }

    return <Stack>{showMonthsData}</Stack>;
  }

  changeMonth(m) {
    const { selectedYear } = this.state;
    if (m != 0) {
      this.requestData(m, selectedYear);
    }
  }

  changeBranch(m) {
    this.setState({ selectedBranch: m });
  }

  setYear(setYear) {
    const { selectedMonth } = this.state;
    this.requestData(selectedMonth, setYear);
  }

  render() {
    const {
      invoices,
      payments,
      refunds,
      bookings,
      selectedYear,
      selectedMonth,
      selectedBranch,
    } = this.state;

    var noRefundOrPayment = this.noRefundOrPaymentcheckInvoices();

    var selectedMonths = allMonths.map((m) => (
      <MenuItem key={uuidv4()} onClick={() => this.changeMonth(m[1])}>
        {m[0]}
      </MenuItem>
    ));

    var selectedBranchItems = allBranchsSelection.map((m) => (
      <MenuItem key={uuidv4()} onClick={() => this.changeBranch(m[1])}>
        {m[0]}
      </MenuItem>
    ));

    /*<MenuList>{selectedMonths}</MenuList>*/

    return (
      <Box w="100%">
        <HStack>
          <Text>Year: </Text>
          <NumberInput
            step={1}
            defaultValue={2022}
            onChange={(valueString) => this.setYear(valueString)}
            value={selectedYear}
          >
            <NumberInputField />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
          <Menu>
            <MenuButton
              as={Button}
              rightIcon={<ChevronDownIcon />}
              colorScheme="teal"
            >
              {selectedMonth}
            </MenuButton>
            <MenuList>{selectedMonths}</MenuList>
          </Menu>
          <Menu>
            <MenuButton
              as={Button}
              rightIcon={<ChevronDownIcon />}
              colorScheme="teal"
            >
              {selectedBranch}
            </MenuButton>
            <MenuList>{selectedBranchItems}</MenuList>
          </Menu>
        </HStack>
        <Stack>{noRefundOrPayment}</Stack>
      </Box>
    );
  }
}

export default Invoices;
